import React, { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button, DatePicker, Space } from 'antd';
import echarts from 'echarts';
import { getItem, getRecentDates, getEchartsData } from './utils/utils';
import { INIT_ECHARTS_OPTS } from './utils/constants';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import theme from './utils/theme.json';

export default function Home() {
  const today = moment().format('YYYY-MM-DD');
  const dateStr = getItem();
  const [option, setOption] = useState(INIT_ECHARTS_OPTS);
  const [end, setEnd] = useState(today);
  echarts.registerTheme('shine', theme);

  useEffect(() => {
    const dateStr = getItem();

    const dateList = getRecentDates(end);

    const { xAxisDate, pData, sData, iData } = getEchartsData(
      dateList,
      dateStr
    );

    const optionCopy = Object.assign({}, option);
    optionCopy.xAxis.data = xAxisDate;
    optionCopy.xAxis.axisPointer.value = end;
    optionCopy.series = [
      {
        name: '体力',
        type: 'line',
        data: pData,
      },
      {
        name: '情绪',
        type: 'line',
        data: sData,
      },
      {
        name: '智力',
        type: 'line',
        data: iData,
      },
    ];

    setOption(optionCopy);
  }, [dateStr, end]);

  useEffect(() => {
    var myChart = echarts.init(document.getElementById('graphic'), 'shine');
    myChart.setOption(option);
  });

  // 测算日期变更回调
  function onChange(date, dateString) {
    setEnd(dateString);
  }

  // 测算日期前移一天
  function onPrev() {
    const current = moment(end);
    setEnd(current.subtract(1, 'days').format('YYYY-MM-DD'));
  }

  // 测算日期后移一天
  function onNext() {
    const current = moment(end);
    setEnd(current.add(1, 'days').format('YYYY-MM-DD'));
  }

  return (
    <div className="block-center">
      <h1>人体生物节律</h1>

      {!dateStr && (
        <Redirect
          to={{
            pathname: '/setting',
          }}
        />
      )}

      <ul>
        <li>
          <Link to="/">主页</Link>
        </li>
        <li>
          <Link to="setting">设置</Link>
        </li>
        <li>
          <Link to="about">关于</Link>
        </li>
      </ul>

      <div
        id="graphic"
        style={{ margin: '10px auto', width: '100%', height: 400 }}
      ></div>

      <div className="block-center">
        <Space>
          <Button onClick={onPrev}>前一天</Button>
          <DatePicker
            locale={locale}
            onChange={onChange}
            defaultValue={moment(end, 'YYYY-MM-DD')}
            value={moment(end, 'YYYY-MM-DD')}
          />
          <Button onClick={onNext}>后一天</Button>
        </Space>
      </div>
    </div>
  );
}
